const jc_url='/service';
const jc_uploadurl='https://jc.jinchen923.com/service';
const base={
    loginbytype:jc_url+'/register/loginbytype',
    getUserInfo:jc_url+'/info/getuserinfo',
    getqrcodebylogin:jc_url+'/register/getqrcodebylogin',
    isqrlogin:jc_url+'/register/isqrlogin',
    getregisterlist1:jc_url+'/backplatform/registerlist1',
    setregister1:jc_url+'/backplatform/setregister1',
    delregister1:jc_url+'/backplatform/delregister1',
    getcardmachinelist:jc_url+'/backplatform/getcardmachinelist',
    editcardmachinerecord:jc_url+'/backplatform/editcardmachinerecord',
    getcardmachinerecordlist:jc_url+'/register/getcardmachinerecordlist',
    getm4backuplist:jc_url+'/backplatform/getm4backuplist',
    getappaccountlist:jc_url+'/backplatform/getappaccountlist',
    getblelocklist:jc_url+'/backplatform/getblelocklist',
    getlockrecord:jc_url+'/info/getlockrecord',
    getgoodsdetail:jc_url+'/goods/getgoodsdetail',
    updateskuprice:jc_url+'/goods/updateskuprice',
    getgoodslist:jc_url+'/goods/getgoodslist',
    goodsedit:jc_url+'/goods/goodsedit',
    getgoodstemplatelist:jc_url+'/goods/getgoodstemplatelist',
    goodstemplateedit:jc_url+'/goods/goodstemplateedit',
    delgoodstemplate:jc_url+'/goods/delgoodstemplate',
    getgoodsvaluelist:jc_url+'/goods/getgoodsvaluelist',
    goodsvalueedit:jc_url+'/goods/goodsvalueedit',   
    delgoodsvalue:jc_url+'/goods/delgoodsvalue',    
    copygoodstemplate:jc_url+'/goods/copygoodstemplate', 
    updategoodsku:jc_url+'/goods/updategoodsku', 
    goodsshangjia:jc_url+'/goods/goodsshangjia',  
    getgoodsorder:jc_url+'/goods/getgoodsorder',
    goodsdelivery:jc_url+'/goods/goodsdelivery',    
}

export const host_file='https://jinchen923.com/storage/'
export const uploadgoods_url=jc_uploadurl+'/upload/goods'
export default base; 